// Auto-generated from backend features.yml
// Source: https://github.com/streemau/backend/blob/master/shared/engines/core/config/features.yml
//
// 🚨 DO NOT EDIT THIS FILE MANUALLY
// To update: npm run types:sync

export const FEATURE_IDS = {
  add_outreach_contact_to_list: 228,
  add_stream: 13,
  advertising_value_mentions: 134,
  advertising_value_widget: 94,
  audio_transcript: 86,
  create_customer_article: 39,
  dashboard_potential_reach: 37,
  dashboard_sentiment: 36,
  dashboard_word_cloud: 40,
  display_magazine_excerpts: 62,
  display_print_excerpts: 55,
  download_outreach_contact: 227,
  expand_magazine_excerpts: 63,
  expand_print_excerpts: 56,
  export_mentions_to_csv: 16,
  full_article_body: 9,
  has_ai_boolean_creator: 211,
  has_ai_content_analysis: 230,
  has_ai_general_assistant: 215,
  has_ai_keyword_suggestion: 205,
  has_ai_mention_streams_creator: 216,
  has_ai_organisation_report_summarisation: 223,
  has_ai_scheduled_report_summarisation: 221,
  has_ai_summarisation: 206,
  has_ai_teams_assistant: 239,
  has_ai_user_context: 232,
  has_ai_visibility: 234,
  has_ai_visibility_module: 251,
  has_aws_ses_v2_email_delivery: 252,
  has_bloomberg_content: 240,
  has_bloomberg_snippets: 241,
  has_broadcast_stories: 229,
  has_cald_sources: 120,
  has_canadian_premium_shareable_content: 197,
  has_cedrom_comprehensive_print_and_digital_news: 185,
  has_cedrom_consumer_current_affairs_and_trade_magazines: 184,
  has_cedrom_eastern_canada_print_and_digital_news: 186,
  has_cedrom_western_canada_print_and_digital_news: 187,
  has_cn2i_content: 209,
  has_combined_print_clippings_pdf: 189,
  has_completed_transcripts_page: 130,
  has_comprehensive_print_and_digital_news_module_govt: 212,
  has_content_teasers: 137,
  has_csl: 191,
  has_daily_highlight: 163,
  has_dashboard_covid_widget: 85,
  has_datahub_content: 180,
  has_datahub_shareable_content: 198,
  has_domain_management: 194,
  has_dow_jones_content: 175,
  has_eastern_canada_print_and_digital_news_govt: 213,
  has_enforced_google_sso: 158,
  has_enforced_microsoft_sso: 140,
  has_enforced_saml: 204,
  has_enforced_two_factor_authentication: 110,
  has_english_language_international_cla: 171,
  has_english_language_international_nla: 170,
  has_english_language_international_other: 172,
  has_enhanced_spike_notifications: 250,
  has_exorde_reddit: 238,
  has_external_items: 132,
  has_factiva_content: 177,
  has_factiva_shareable_content: 190,
  has_feature_teasers: 136,
  has_financial_times_direct_pdf_access: 199,
  has_financial_times_online: 159,
  has_french_wise_public: 202,
  has_front_pages: 121,
  has_geographic_spread_chart: 46,
  has_globe_and_mail_content: 176,
  has_help_menu: 125,
  has_inclusion_of_media_items_pdf_with_afr_clippings: 108,
  has_insights_plus_teasers: 141,
  has_insights_reports: 114,
  has_insights_v2: 222,
  has_instant_edit_media_item: 129,
  has_instant_edit_transcript: 128,
  has_instant_insights: 124,
  has_instant_insights_year_on_year: 52,
  has_international_max: 135,
  has_international_plus: 104,
  has_journalist_enquiries: 109,
  has_kinetiq_broadcast: 235,
  has_kinetiq_broadcast_anz: 243,
  has_kinetiq_broadcast_canada: 245,
  has_kinetiq_broadcast_cutover: 242,
  has_kinetiq_broadcast_europe: 247,
  has_kinetiq_broadcast_rest_of_world: 248,
  has_kinetiq_broadcast_uk: 246,
  has_kinetiq_broadcast_us_canada: 244,
  has_kinetiq_download_capability: 249,
  has_launchpad: 1,
  has_launchpad_competitor_charts: 133,
  has_le_devoir_content: 207,
  has_lexisnexis_online: 142,
  has_lexisnexis_print: 143,
  has_lexisnexis_shareable_content: 195,
  has_media_impact_time_chart: 47,
  has_media_platform: 103,
  has_mediatrack_apac: 192,
  has_mediatrack_international: 200,
  has_mediatrack_nla_regional: 161,
  has_minimash_content: 210,
  has_new_york_times_content: 174,
  has_new_york_times_shareable_content: 196,
  has_nla_eclips_print: 153,
  has_nla_eclips_print_financial_times: 154,
  has_nla_eclips_web: 152,
  has_organisation_report_analytics_dashboard_widget: 48,
  has_organisation_report_audience: 100,
  has_organisation_report_automated_sentiment_ratings: 107,
  has_organisation_report_broadcast_preview_links: 75,
  has_organisation_report_frontpage_widget: 90,
  has_organisation_report_mention_summaries: 179,
  has_organisation_report_plain_text_links: 50,
  has_organisation_report_viewer: 53,
  has_organisation_report_viewer_broadcast_items: 99,
  has_organisation_report_viewer_toggle: 72,
  has_outreach: 138,
  has_outreach_activities_lists_search: 145,
  has_outreach_ai_pitch: 203,
  has_outreach_discover: 237,
  has_outreach_mailing_lists: 147,
  has_outreach_media_releases: 146,
  has_outreach_profile_suggested_contacts: 220,
  has_outreach_search_only: 144,
  has_paper_article_title: 66,
  has_public_api: 193,
  has_push_to_team: 127,
  has_qmi_content: 208,
  has_react_score: 169,
  has_region_selector: 83,
  has_reports: 123,
  has_restricted_content_sharing_to_team: 131,
  has_rss_full_body: 236,
  has_search: 122,
  has_search_available_content: 84,
  has_sentiment_rating_mode: 60,
  has_similar_mentions: 126,
  has_singapore_press_holdings_online_content: 218,
  has_smart_suggested_contacts: 219,
  has_social_engage: 113,
  has_social_platform: 102,
  has_team_workspaces: 183,
  has_tinymce_editor: 231,
  has_tv_eyes_download_capability: 178,
  has_tveyes_broadcast_anz: 155,
  has_tveyes_broadcast_canada: 188,
  has_tveyes_broadcast_europe: 165,
  has_tveyes_broadcast_rest_of_world: 157,
  has_tveyes_broadcast_uk: 160,
  has_tveyes_broadcast_us_canada: 156,
  has_uk_clipped_content_cla: 167,
  has_uk_clipped_content_nla: 166,
  has_uk_clipped_content_other: 168,
  has_usage: 95,
  has_user_self_management: 93,
  has_vs_market_chart: 81,
  has_wise_bonnier: 173,
  has_wise_cla: 151,
  has_wise_nla: 150,
  has_wise_public: 149,
  list_outreach_contact: 225,
  magazine_mentions: 32,
  media_request: 97,
  mention_delivery: 98,
  online_mentions: 23,
  organisation_report_jump_links: 74,
  play_radio_clips: 22,
  play_tv_clips: 21,
  podcast_mentions: 115,
  print_mentions: 12,
  radio_excerpts: 11,
  radio_mentions: 25,
  read_customer_article: 38,
  read_online_article: 20,
  report_online_summary: 64,
  report_print_summary: 65,
  share_online_broadcast: 96,
  social_mentions: 3,
  streams_reports: 4,
  translate_online_and_print_content: 181,
  tv_mentions: 24,
  view_blog_post: 105,
  view_bluesky_post: 214,
  view_facebook_post: 68,
  view_forum_post: 106,
  view_instagram_post: 89,
  view_linkedin_post: 217,
  view_magazine_articles: 33,
  view_magazine_articles_warning: 34,
  view_new_zealand_broadcast_content: 139,
  view_new_zealand_online_content: 117,
  view_new_zealand_print_and_magazine_content: 111,
  view_newspaper_frontpage: 91,
  view_non_new_zealand_content: 201,
  view_outreach_contact: 226,
  view_paper_articles: 18,
  view_paper_articles_warning: 19,
  view_podcast_episode: 116,
  view_print_articles: 118,
  view_print_articles_warning: 119,
  view_radio_clip: 71,
  view_reddit_post: 101,
  view_tiktok_video: 224,
  view_tv_caption: 69,
  view_tv_logo_appearance: 78,
  view_tv_super: 70,
  view_tweet: 67,
  view_youtube_video: 76,
} as const;

export type FeatureKey = keyof typeof FEATURE_IDS;

// Generated 210 features with ID mappings
